export default "__VITE_PUBLIC_ASSET__f5a8a7e3__"